import { render, staticRenderFns } from "./place-info.vue?vue&type=template&id=745cbc16&scoped=true&"
import script from "./place-info.vue?vue&type=script&lang=js&"
export * from "./place-info.vue?vue&type=script&lang=js&"
import style0 from "./place-info.vue?vue&type=style&index=0&id=745cbc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745cbc16",
  null
  
)

export default component.exports